var _defs, _path, _path2, _line, _circle, _line2, _path3, _path4, _line3, _circle2, _path5, _line4, _polyline, _line5, _line6, _line7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollisioncopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:10.29px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m237.54,293.97l1.39,9.36c.35,3.2,3.22,5.51,6.42,5.16l30.39-3.3h.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m396.27,162.6c-19.15,7.11-37.11,17.44-53.04,30.56l-33.99,27.93-39.13,8.09-11.99-4.31-9.31,13.95-8.33-.72,8.82,16.17-11.76,11.76,13.23,7.35-13.23,20.58"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 410.16,
    y1: 290.6,
    x2: 370.79,
    y2: 294.87
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.82,
    cy: 289.5,
    r: 38.36,
    transform: "translate(-109.57 350.29) rotate(-51.2)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 401.53,
    y1: 211.07,
    x2: 340.18,
    y2: 217.73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.66,304.94l17.85,2.07c3.57.42,7.18-.62,10.02-2.86l17.48-13.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.79,156.9l47.73,5.51c8.12.94,15.84,4.11,22.28,9.16l36.23,28.46c6.51,5.09,13.89,8.93,21.8,11.31l21.02,6.3-8.47,14.3,20.58,2,8.73,13.54-7.09,21.22-16.4,8.73,10.79,12.85"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.09,
    y1: 293.44,
    x2: 38.39,
    y2: 290.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.29,
    cy: 300.39,
    r: 37.97,
    transform: "translate(-159.3 143.47) rotate(-38.41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.68,213.38c-5.77,3.32-11.74,6.72-16.2,9.18-2.79,1.54-5.99,2.16-9.15,1.8l-71.38-8.25"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.4,
    y1: 166.12,
    x2: 103.86,
    y2: 222.68
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "181.67 188.11 155.2 136.65 208.13 170.46 233.13 110.18 241.95 174.88 312.52 149.88 278.7 199.87"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 308.8,
    y1: 193.88,
    x2: 316.25,
    y2: 185.86
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 265.11,
    y1: 138.22,
    x2: 270.89,
    y2: 128.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 197.07,
    y1: 139.63,
    x2: 189.8,
    y2: 122.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollisioncopy2);
export default __webpack_public_path__ + "static/media/Collision copy 2.da040bfe1367c8264b7a2cda1510d093.svg";
export { ForwardRef as ReactComponent };